/**
* @name: government
* @author: weiyong
* @date: 2023-04-01 21:06
* @description：government
* @update: 2023-04-01 21:06
*/
<template>
  <div :class="prefixCls" class="classicBlue wrapper-horizontal"  :style="'--left-menu-width:'+getLeftMenuWidth+'px'">
    <header-bar-page :settingLayout="settingLayout"/>
    <div class="center-body flex-div w100b">
      <left-layout/>

      <right-layout-div :systemFlag="isNotSystem"/>
    </div>
  </div>
</template>

<script lang="ts">

import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "classicBlue",
});
</script>

<script lang="ts" setup>
import {usePageFlush} from "@/hooks/setting/usePageFlush";
import LeftLayout from "@/layouts/layoutFrame/classicBlue/components/leftLayout/index.vue";
import RightLayoutDiv from "@/layouts/layoutFrame/classicBlue/components/right-layout-div.vue";
import HeaderBarPage from "@/layouts/layoutFrame/classicBlue/components/header-bar-page.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {ref} from "vue";
import GoingUtils from "@/utils/goingUtils";
import {StorageUtils} from 'xmgoing-utils';
import {useRootSetting} from "@/hooks/setting/useRootSetting";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {MenuModeEnum, MenuTypeEnum} from "@/enums/menuEnum";

baseHandler(HandlerEnum.CHANGE_LAYOUT, {
  mode: MenuModeEnum.INLINE,
  type: MenuTypeEnum.SIDEBAR,
  split: false,
});

const {prefixCls} = useDesign('scaLayout');
const itemMenu = ref({});

const { getLeftMenuWidth } = useRootSetting();
const isNotSystem=computed(()=>{
  try{
    return !GoingUtils.isSystem(JSON.parse(StorageUtils.getSessionItem("curUserJson")+"").position)
  }catch (e){
    return  false;
  }
})
onMounted(()=>{
  if(!(document.body.className.indexOf('classicBlue-body')>=0)){
    document.body.className=document.body.className+" classicBlue-body";
  }
})

const props=defineProps({
  settingLayout:{
    type:Boolean,
    default:true
  }
})
//刷新界面的hook
usePageFlush();
</script>

<style type="text/css" lang="less">
@import './less/classicBlue.less';
.classicBlue{
  .center-body{
    position: relative;
    height:calc(100% - var(--header-height,60px));
    top:var(--header-height,60px);
  }
  &.groupAdmin{
    .go-page {
      overflow: hidden;;
      &#frame{
        position: relative; z-index: 10; padding: 12px;
      }
    }
  }
}

</style>
